"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var FanFilled_1 = __importDefault(require("../../icons/generated/FanFilled"));
var styled_components_1 = __importDefault(require("styled-components"));
var active_pump_icon_component_1 = __importDefault(require("../../icons/animated/active-pump-icon.component"));
var active_mixer_icon_component_1 = __importDefault(require("../../icons/animated/active-mixer-icon.component"));
var map_installation_card_component_1 = __importDefault(require("../../map/map-installation-card.component"));
var dark_theme_1 = __importDefault(require("../../../global/dark-theme"));
var alarm_warning_pump_icon_component_1 = __importDefault(require("../../icons/animated/alarm-warning-pump-icon.component"));
var static_pump_icon_component_1 = __importDefault(require("../../icons/static/static-pump-icon.component"));
var stateColor = function (state, theme) {
    var _a = theme.colours.installationSketch, allGood = _a.allGood, warnings = _a.warnings, alerts = _a.alerts, disabled = _a.disabled, undetermined = _a.undetermined;
    if (state === 'alert')
        return alerts;
    if (state === 'warning')
        return warnings;
    if (state === 'disabled')
        return disabled;
    if (state === 'undetermined')
        return undetermined;
    return allGood;
};
var DeviceContainer = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 24px;\n  position: relative;\n  .spinner {\n    border-color: ", ";\n  }\n\n  .pulsar {\n    border-color: ", ";\n  }\n\n  & > div > svg {\n    fill: ", ";\n  }\n"], ["\n  margin-right: 24px;\n  position: relative;\n  .spinner {\n    border-color: ", ";\n  }\n\n  .pulsar {\n    border-color: ", ";\n  }\n\n  & > div > svg {\n    fill: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme, state = _a.state;
    return stateColor(state, theme);
}, function (_a) {
    var theme = _a.theme, state = _a.state;
    return stateColor(state, theme);
}, function (_a) {
    var theme = _a.theme, state = _a.state;
    return stateColor(state, theme);
});
var CardWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: -75px;\n"], ["\n  position: absolute;\n  top: -75px;\n"])));
exports.Pump = function (_a) {
    var isActive = _a.isActive, state = _a.state, title = _a.title, warnings = _a.warnings, errors = _a.errors;
    var _b = react_1.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    return (react_1.default.createElement(DeviceContainer, { state: state, "data-test-id": 'sketch-device-pump', onMouseEnter: function () { return setIsFocused(true); }, onMouseLeave: function () { return setIsFocused(false); } },
        isActive && state === 'all-good' && react_1.default.createElement(active_pump_icon_component_1.default, { state: state, theme: dark_theme_1.default }),
        isActive && state !== 'all-good' && react_1.default.createElement(alarm_warning_pump_icon_component_1.default, { state: state, theme: dark_theme_1.default }),
        !isActive && react_1.default.createElement(static_pump_icon_component_1.default, { state: state, theme: dark_theme_1.default }),
        isFocused && (react_1.default.createElement(CardWrapper, null,
            react_1.default.createElement(map_installation_card_component_1.default, { arrowDirection: "down", title: title, warnings: warnings, errors: errors })))));
};
exports.Pump.displayName = 'Pump';
exports.Mixer = function (_a) {
    var isActive = _a.isActive, state = _a.state, title = _a.title, warnings = _a.warnings, errors = _a.errors;
    var _b = react_1.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    return (react_1.default.createElement(DeviceContainer, { state: state, "data-test-id": 'sketch-device-mixer', onMouseEnter: function () { return setIsFocused(true); }, onMouseLeave: function () { return setIsFocused(false); } },
        isActive && react_1.default.createElement(active_mixer_icon_component_1.default, null),
        !isActive && react_1.default.createElement(FanFilled_1.default, null),
        isFocused && (react_1.default.createElement(CardWrapper, null,
            react_1.default.createElement(map_installation_card_component_1.default, { arrowDirection: "down", title: title, warnings: warnings, errors: errors })))));
};
exports.Mixer.displayName = 'Mixer';
var templateObject_1, templateObject_2;
//# sourceMappingURL=sketch-devices.component.js.map